import { createContext } from "react";

export const CMContext = createContext(null);
